import { render, staticRenderFns } from "./templateListModal.vue?vue&type=template&id=228838bc&"
import script from "./templateListModal.vue?vue&type=script&lang=ts&"
export * from "./templateListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports